import React, { createRef, useEffect } from 'react';
import { connect } from 'react-redux';
import { PropTypes } from 'prop-types';
import { getTopContributors, getContributorsLoading } from '../selectors';
import { topContributorsRequested } from '../actions';
import { DROPDOWNDATA } from './constants';
import TopContributorsCard from '../../../common/TopContributorsCard';
import downloadAsImage from '../../../helpers/downloadAsImage';

function TopContributors({ onLoad, topContributors, contributorsLoading }) {
    useEffect(() => {
        onLoad(DROPDOWNDATA[0].key);
    }, []);
    const ref = createRef();

    return (
        <TopContributorsCard
            topContributors={topContributors}
            loading={contributorsLoading}
            onSelect={onLoad}
            className="h-100 d-flex flex-column"
            downloadable={true}
            onDownloadClick={(filetype) => {
                if (ref) {
                    downloadAsImage(ref.current, 'topContributors', filetype);
                }
            }}
            ref={ref}
        />
    );
}

TopContributors.propTypes = {
    // function to be called when component is initialized
    onLoad: PropTypes.func.isRequired,
    // contributors to be listed in component
    topContributors: PropTypes.arrayOf(PropTypes.object).isRequired,
    // boolean value to determine whether to show the loader
    contributorsLoading: PropTypes.bool,
};

const mapStateToProps = (state) => {
    return {
        topContributors: getTopContributors(state),
        contributorsLoading: getContributorsLoading(state),
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        onLoad: (date, customDate) =>
            dispatch(topContributorsRequested(date, customDate)),
    };
};

const ConnectedTopContributors = connect(
    mapStateToProps,
    mapDispatchToProps,
)(TopContributors);

export default ConnectedTopContributors;
